module.exports = __webpack_public_path__ + "left-arrow.a23e57496a828521b0301793410e49d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/left-arrow.svg
// module id = 1141
// module chunks = 0